import { FormattedMessage } from "react-intl";

import {
  TableHead,
  TableHeader,
  TableRow,
} from "@ps-design-system/components/Table";
import { Text } from "@ps-design-system/components/Text";

/** Header row of the date rate table: "Description" and "Hourly price". */
const DateRateTableHeader = () => (
  <TableHeader>
    <TableRow className="tw-bg-gray-100 tw-border-solid tw-border-gray-400">
      <TableHead className="tw-h-auto tw-p-16 tw-w-1/2">
        <Text typeface="headline-1-m">
          <FormattedMessage
            id="hosting.date_rate_table.description_heading"
            defaultMessage="Description"
          />
        </Text>
      </TableHead>
      <TableHead className="tw-h-auto tw-p-16 tw-w-[35%] tw-text-right">
        <Text typeface="headline-1-m">
          <FormattedMessage
            id="hosting.date_rate_table.hourly_price_heading"
            defaultMessage="Hourly price"
          />
        </Text>
      </TableHead>
      <TableHead className="tw-h-auto tw-p-0 tw-w-[15%]" />
    </TableRow>
  </TableHeader>
);

export { DateRateTableHeader };
